var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPancreatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.4999C4 9.11988 6.74 6.37988 10.12 6.37988",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.12 18.6202C6.74 18.6202 4 15.8802 4 12.4902",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8991 16.3301C13.7391 17.7701 11.9691 18.6201 10.1191 18.6201",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0795 15.4604C8.38953 15.4604 7.01953 14.0904 7.01953 12.4004",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92969 9.34036C11.2697 9.20036 12.6097 9.28036 13.8897 9.36036C14.0197 9.36036 14.9097 9.39037 15.2497 9.39037C15.3797 9.39037 15.5997 9.39036 15.7297 9.37036C16.0897 9.34036 16.7997 9.22036 17.1697 9.21036C18.1097 9.16036 18.9897 10.4804 18.4697 11.2604C18.3497 11.4404 18.0897 11.7904 17.9697 11.9704C17.7297 12.3304 17.2197 12.5304 16.8497 12.7504C15.6797 13.4404 13.9297 12.5704 12.0097 14.7304C11.5497 15.2504 10.8097 15.4304 10.0797 15.4704",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2498 15.1704C10.5204 15.1704 10.7397 14.951 10.7397 14.6804C10.7397 14.4098 10.5204 14.1904 10.2498 14.1904C9.97914 14.1904 9.75977 14.4098 9.75977 14.6804C9.75977 14.951 9.97914 15.1704 10.2498 15.1704Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01953 12.3998C7.01953 10.7098 8.38953 9.33984 10.0795 9.33984",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3809 13.1699L15.7009 13.2599C16.6909 13.5499 17.5108 14.3199 17.7108 15.3299C17.7308 15.4399 17.7509 15.5399 17.7509 15.6499L17.8809 21.6099",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 16.3301L15.0104 21.6101",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6191 9.26C12.5591 9.17 13.4191 8.54 13.7091 7.23C13.7091 7.23 13.7292 7.04 13.7292 3",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.34L10.27 3",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53024 12.0302C9.55233 12.0302 9.57025 12.0123 9.57025 11.9902C9.57025 11.9681 9.55233 11.9502 9.53024 11.9502C9.50815 11.9502 9.49023 11.9681 9.49023 11.9902C9.49023 12.0123 9.50815 12.0302 9.53024 12.0302Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9391 12.1398C12.0219 12.1398 12.0891 12.0727 12.0891 11.9898C12.0891 11.907 12.0219 11.8398 11.9391 11.8398C11.8562 11.8398 11.7891 11.907 11.7891 11.9898C11.7891 12.0727 11.8562 12.1398 11.9391 12.1398Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7409 10.2397C13.7575 10.2397 13.7709 10.2263 13.7709 10.2097C13.7709 10.1931 13.7575 10.1797 13.7409 10.1797C13.7244 10.1797 13.7109 10.1931 13.7109 10.2097C13.7109 10.2263 13.7244 10.2397 13.7409 10.2397Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4109 11.4301C15.4274 11.4301 15.4409 11.4167 15.4409 11.4001C15.4409 11.3835 15.4274 11.3701 15.4109 11.3701C15.3943 11.3701 15.3809 11.3835 15.3809 11.4001C15.3809 11.4167 15.3943 11.4301 15.4109 11.4301Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1609 10.7796C18.1774 10.7796 18.1909 10.7483 18.1909 10.7096C18.1909 10.671 18.1774 10.6396 18.1609 10.6396C18.1443 10.6396 18.1309 10.671 18.1309 10.7096C18.1309 10.7483 18.1443 10.7796 18.1609 10.7796Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancreatic);
export default __webpack_public_path__ + "static/media/Pancreatic.a28b801cd1033ff7319ca4497c77f4b7.svg";
export { ForwardRef as ReactComponent };